export const propertyQueryKeys = {
  all: ["propertyChildren"] as const,
  children: (propertyTicker: string) => [...propertyQueryKeys.all, propertyTicker] as const,
};
